import { SupportTicketStatus, SupportTicketType } from '~/db_types/swagger_types';
export const SupportTicketStatusDisplay = new Map([
    [SupportTicketStatus.AWAITING_CUSTOMER_REVIEW, 'Awaiting customer review'],
    [SupportTicketStatus.AWAITING_MORE_INFORMATION, 'Awaiting more information'],
    [SupportTicketStatus.NEW, 'New'],
    [SupportTicketStatus.TRIAGED, 'Triaged'],
    [SupportTicketStatus.UNDER_INVESTIGATION, 'Under investigation']
]);
export const SupportTicketTypeDisplay = new Map([
    [SupportTicketType.BUG, 'Bug'],
    [SupportTicketType.FEATURE_REQUEST, 'Feature request'],
    [SupportTicketType.QUESTION, 'Question'],
    [SupportTicketType.UNCATEGORIZED, 'Uncategorized']
]);
